import { DYNAMIC_MODAL_VIEWS } from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';
// all dynamic modals imports:
import { ModalQualityAlert } from './modal-quality-alert/ModalQualityAlert';
import { ModalMultiplePurchase } from './modal-multiple-purchase/ModalMultiplePurchase';
import { ModalDelete } from './modal-delete/ModalDelete';
import { ModalEmptyImages } from './modal-empty-images/ModalEmptyImages';
import { ModalUploadToCart } from './modal-upload-to-cart/ModalUploadToCart';
import { ModalErrorCart } from './modal-error-cart/ModalErrorCart';
import { ModalSaveChanges } from './modal-save-changes/ModalSaveChanges';
import { ModalApplyAll } from './modal-apply-all/ModalApplyAll';
import { ModalUpSelling } from './modal-up-selling/ModalUpSelling';
import { ModalUploadMultiSource } from './modal-upload-multisource/ModalUploadMultisource';
import { ModalPrivacyPolicy } from './modal-privacy-policy/ModalPrivacyPolicy';
import { ModalCutAlert } from './modal-cut-alert/ModalCutAlert';
import { ModalEditProducts } from './modal-edit-products/ModalEditProducts';
import { ModalConfigurationSteps } from './modal-configuration-steps/ModalConfigurationSteps';
import { ModalAdjustCrops } from './modal-adjust-crops/ModalAdjustCrops';
import { ModalCutConfirmationAlert } from './modal-cut-confirmation-alert/ModalCutConfirmationAlert';
import { DYNAMIC_MODAL_TYPES, DynamicModalProps } from './DynamicModal.types';
import { ModalExitProject } from './modal-exit-project/ModalExitProject';
import { ModalDeleteAll } from './modal-delete-all/ModalDeleteAll';
import { ModalPhotoDrawerOrder } from './modal-photo-drawer-order/ModalPhotoDrawerOrder';
import { ModalDeleteFromDrawer } from './modal-delete-from-drawer/ModalDeleteFromDrawer';
import { ModalOverLimitProducts } from './modal-over-limit-products/ModalOverLimitProducts';
import { ModalMinProductsAlert } from './modal-min-products-alert/ModalMinProductAlert';
import { ModalUnderMinLimitProducts } from './modal-under-min-limit-products/ModalUnderMinLimitProducts';
import { ModalUploadError } from './modal-upload-error/ModalUploadError';
import { ModalNetwork } from './modal-network/ModalNetwork';
import { ModalMaxProductsAlert } from './modal-max-products-alert/ModalMaxProductAlert';
import { ModalNoAvailableSpace } from './modal-no-available-space/ModalNoAvailableSpace';
import { ModalNewVersionAvailable } from './modal-new-version-available/ModalNewVersionAvailable';
import { ModalProductNotAvailable } from './modal-product-not-available/ModalProductNotAvailable';

export const DynamicModalMap: Record<
  DYNAMIC_MODAL_VIEWS,
  {
    component: React.ComponentType<DynamicModalProps>;
    type: DYNAMIC_MODAL_TYPES;
  }
> = {
  // POPUP
  [DYNAMIC_MODAL_VIEWS.QualityAlert]: { component: ModalQualityAlert, type: DYNAMIC_MODAL_TYPES.Popup },
  [DYNAMIC_MODAL_VIEWS.MultiplePurchase]: { component: ModalMultiplePurchase, type: DYNAMIC_MODAL_TYPES.Popup },
  [DYNAMIC_MODAL_VIEWS.DeleteProduct]: { component: ModalDelete, type: DYNAMIC_MODAL_TYPES.Popup },
  [DYNAMIC_MODAL_VIEWS.EmptyImages]: { component: ModalEmptyImages, type: DYNAMIC_MODAL_TYPES.Popup },
  [DYNAMIC_MODAL_VIEWS.UploadToCart]: { component: ModalUploadToCart, type: DYNAMIC_MODAL_TYPES.Popup },
  [DYNAMIC_MODAL_VIEWS.ErrorCart]: { component: ModalErrorCart, type: DYNAMIC_MODAL_TYPES.Popup },
  [DYNAMIC_MODAL_VIEWS.SaveChanges]: { component: ModalSaveChanges, type: DYNAMIC_MODAL_TYPES.Popup },
  [DYNAMIC_MODAL_VIEWS.ApplyAll]: { component: ModalApplyAll, type: DYNAMIC_MODAL_TYPES.Popup },
  [DYNAMIC_MODAL_VIEWS.ModalUpSelling]: { component: ModalUpSelling, type: DYNAMIC_MODAL_TYPES.Popup },
  [DYNAMIC_MODAL_VIEWS.UploadMultiSource]: { component: ModalUploadMultiSource, type: DYNAMIC_MODAL_TYPES.Popup },
  [DYNAMIC_MODAL_VIEWS.PrivacyPolicy]: { component: ModalPrivacyPolicy, type: DYNAMIC_MODAL_TYPES.Popup },
  [DYNAMIC_MODAL_VIEWS.CutAlert]: { component: ModalCutAlert, type: DYNAMIC_MODAL_TYPES.Popup },
  [DYNAMIC_MODAL_VIEWS.CutConfirmationAlert]: { component: ModalCutConfirmationAlert, type: DYNAMIC_MODAL_TYPES.Popup },
  [DYNAMIC_MODAL_VIEWS.ConfigurationSteps]: { component: ModalConfigurationSteps, type: DYNAMIC_MODAL_TYPES.Popup },
  [DYNAMIC_MODAL_VIEWS.ExitProject]: { component: ModalExitProject, type: DYNAMIC_MODAL_TYPES.Popup },
  [DYNAMIC_MODAL_VIEWS.DeleteAll]: { component: ModalDeleteAll, type: DYNAMIC_MODAL_TYPES.Popup },
  [DYNAMIC_MODAL_VIEWS.DeleteFromDrawer]: { component: ModalDeleteFromDrawer, type: DYNAMIC_MODAL_TYPES.Popup },
  [DYNAMIC_MODAL_VIEWS.PhotoDrawerOrder]: { component: ModalPhotoDrawerOrder, type: DYNAMIC_MODAL_TYPES.Popup },
  [DYNAMIC_MODAL_VIEWS.OverLimitProducts]: { component: ModalOverLimitProducts, type: DYNAMIC_MODAL_TYPES.Popup },
  [DYNAMIC_MODAL_VIEWS.UnderMinLimitProducts]: {
    component: ModalUnderMinLimitProducts,
    type: DYNAMIC_MODAL_TYPES.Popup,
  },
  [DYNAMIC_MODAL_VIEWS.MaxProductsAlert]: { component: ModalMaxProductsAlert, type: DYNAMIC_MODAL_TYPES.Popup },
  [DYNAMIC_MODAL_VIEWS.MinProductsAlert]: { component: ModalMinProductsAlert, type: DYNAMIC_MODAL_TYPES.Popup },
  [DYNAMIC_MODAL_VIEWS.ModalUploadError]: { component: ModalUploadError, type: DYNAMIC_MODAL_TYPES.Popup },
  [DYNAMIC_MODAL_VIEWS.ModalNetwork]: { component: ModalNetwork, type: DYNAMIC_MODAL_TYPES.Popup },
  [DYNAMIC_MODAL_VIEWS.NoAvailableSpace]: { component: ModalNoAvailableSpace, type: DYNAMIC_MODAL_TYPES.Popup },
  [DYNAMIC_MODAL_VIEWS.NewVersionAvailable]: { component: ModalNewVersionAvailable, type: DYNAMIC_MODAL_TYPES.Popup },
  [DYNAMIC_MODAL_VIEWS.ProductNotAvailable]: { component: ModalProductNotAvailable, type: DYNAMIC_MODAL_TYPES.Popup },

  // FULLSCREEN
  [DYNAMIC_MODAL_VIEWS.EditProducts]: {
    component: ModalEditProducts,
    type: DYNAMIC_MODAL_TYPES.FullScreen,
  },
  [DYNAMIC_MODAL_VIEWS.AdjustCrops]: {
    component: ModalAdjustCrops,
    type: DYNAMIC_MODAL_TYPES.FullScreen,
  },
  [DYNAMIC_MODAL_VIEWS.ConfigurationStepsMobile]: {
    component: ModalConfigurationSteps,
    type: DYNAMIC_MODAL_TYPES.FullScreen,
  },
};
